/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SupportLink/view.blocks to change it.
import React from 'react'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'



/** @type {import('Simple/types.js').View} */
export default function SupportLink({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Details/Office/Search/Content/Content/Offices/Error/SupportLink"
  
}) {
  return (<React.Fragment
>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 marginTop={50}
 text="Need Help?"
 goTo="https://support.greyfinch.com"
/>
{children}
</React.Fragment>)
}